export default __webpack_public_path__ + "static/media/zenstrin-logo.d5fb5e02.png";